import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../../Utils/loadingAnimation.js';
import Network from '../../../Utils/network.js';
import GeneralUtils from '../../../Utils/generalUtils.js';
import { Tooltip } from 'reactstrap';
import SliderModal from '../../../Utils/sliderModal.js';
import Swal from 'sweetalert2';
import infoIcon from '../../../ImageAssets/infoIcon.png';
import PaypalLogo from '../../../ImageAssets/paypal.png';
import RechargeComponent from '../RechargeComponent';


class PaymentComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            profileId: "NA",
            isPaymentModalVisible: true,
            payaplPaymentMethodAllowed: false,
            isPaymentFromMainBalanceAllowed: false,
            isPaypalChecked: false,
            paypalClientId: "",
            paypalAmount: "",
            accountId: "",
            firstName: "",
            lastName: "",
            emailId: "",
            phoneNumber: "",
            paymentAmount: "",
            finalPaymentAmount: "",
            expiryDate: "",
            paymentReceipt: "",
            ransactionId: "",
            token: "",
            fundingSource: "",
            diffAmount: 0,
            cardType: "",
            rangeVal: "0",
            isRewardInfoTooltipOpen: false,
            rewardPointsFromLMS: "0",
            isRewardPointUsingForPayment: false,
            redemptionPoint: 0,
            totalAmountToPay: 0,
            maxLoyaltyPoint: 0,
            isLoading: true,
            isRedeemable: false,
            isPaypalButtonRendered: false,
            maBalance: "0",
            isRechargeComponentVisible: false,
            isPrepaidAddonExists: false,
            isHybridService: false,
            totalCharges: 0,
            totalAmountWithRedemption: 0,
            allExistingAddonIds: [],
            isPostpaidService: false,
            currentCreditLimit: 0
        }
    }

    generateReceiptNumber = () => {
        var number = Math.floor(100000 + Math.random() * 900000);
        number = "SCM" + number;
        return number;
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('message', this.processMessage);
    }

    componentDidMount() {
        this.updateWindowDimensions();

        window.removeEventListener('resize', this.updateWindowDimensions);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('message', this.processMessage);

        window.addEventListener('resize', this.updateWindowDimensions);
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('message', this.processMessage, false);

        this.setState({
            isLoading: true,
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            paymentAmount: this.props.amount,
            finalPaymentAmount: this.props.amount,
            accountId: this.props.accountId,
            phoneNumber: this.props.phoneNumber,
            emailId: this.props.emailId,
            profileId: this.props.profileId
        })

        var receivedAmount = parseFloat((this.state.paymentAmount.replace(',', '')))
        if (parseFloat(this.state.finalPaymentAmount) > (parseFloat(receivedAmount))) {
            var diffAmount = parseFloat(this.state.finalPaymentAmount) - parseFloat(receivedAmount)
        }

        var currentCreditLimit = 0;
        if(this.props.registerDetails.generalResponse.currentCreditLimit){
            currentCreditLimit=this.props.registerDetails.generalResponse.currentCreditLimit;
        }


        Network.executeAxios("getPaypalClientId", "GET", "", (response) => {
            this.initialiseRedemptionPoint()
            this.setState({
                paypalClientId: response.CLIENT_ID,
                currentCreditLimit: currentCreditLimit,
                paypalAmount: GeneralUtils.formatNumberToStandardForm(this.state.finalPaymentAmount,this.props.configurationValues),
                isLoading: false,
                diffAmount: diffAmount
            })

        });
    }

    myCallback = (isPaymentComponentEnabled, isReceiptModalVisible, transactionId, finalRechargeAmount) => {
        var totalRewardPointsUsed = 0
        this.setState({ isRechargeComponentVisible: true, isReceiptModalVisible: false })
        this.props.callbackFromParent(this.state.isRechargeComponentVisible, this.state.isReceiptModalVisible, "", "", totalRewardPointsUsed, "");
    }

    initialiseRedemptionPoint() {
        var redemptionPoint = "0";
        try {
            var ccmConfig = this.props.cache.ccmConfigResponse;
            redemptionPoint = ccmConfig["_embedded"].configs[0].configValue;
        } catch (err) {

        }

        var connectionTypeArr = [];
        var isRedeemable = false;
        var maxLoyaltyPoint = 0;
        for (var i = 0; i < this.props.registerDetails.customize.addons.length; i++) {
            if (this.props.registerDetails.customize.addons[i].isRedeemable) {
                if (this.props.registerDetails.customize.addons[i].connectionType.toUpperCase() === "PREPAID") {
                    isRedeemable = true
                    maxLoyaltyPoint = maxLoyaltyPoint + parseFloat(this.props.registerDetails.customize.addons[i].offerAmount || 0 * this.props.registerDetails.customize.addons[i].count)
                }
            }
            connectionTypeArr.push(this.props.registerDetails.customize.addons[i].connectionType.toUpperCase())
        }
        connectionTypeArr.push(this.props.registerDetails.offers.connectionType);
        if (connectionTypeArr.includes("PREPAID")) {
            this.setState({ isPrepaidAddonExists: true, isPaymentFromMainBalanceAllowed: true, maBalance: this.props.registerDetails.generalResponse.maBalance, mainBalancePayment: true, payaplPaymentMethodAllowed: true })
        } else {
            this.setState({ isPostpaidService: true })
        }
        if (connectionTypeArr.includes("PREPAID") && connectionTypeArr.includes("POSTPAID")) {
            this.setState({ isHybridService: true })
        }
        console.log("maxLoyalty>>>>", maxLoyaltyPoint)

        var rewardPointsFromLMS = 0;
        if (this.props.cache.rewardPointsFromLMS !== "0" && this.props.cache.rewardPointsFromLMS != undefined) {
            rewardPointsFromLMS = parseInt(this.props.cache.rewardPointsFromLMS);
        }

        // if(parseFloat(this.props.amount) > 0){
        //     sum = parseFloat(this.props.amount)
        //     sum = GeneralUtils.formatNumberToStandardForm(sum)
        // }

        var totalAmountToPayForPrepaid = 0;
        var priceRequiredForRedeeption = parseFloat(maxLoyaltyPoint * redemptionPoint)
        if (priceRequiredForRedeeption <= rewardPointsFromLMS) {
            this.setState({ totalAmountWithRedemption: maxLoyaltyPoint })
            totalAmountToPayForPrepaid = parseFloat(this.props.totalAmountToPay - maxLoyaltyPoint);
        } else {
            totalAmountToPayForPrepaid = this.props.totalAmountToPay
        }
        this.setState({ totalAmountToPayForPrepaid: totalAmountToPayForPrepaid, isRedeemable: isRedeemable, rewardPointsFromLMS: rewardPointsFromLMS, redemptionPoint: redemptionPoint, totalAmountToPay: this.props.totalAmountToPay, totalCharges: parseFloat(this.props.amount), maxLoyaltyPoint: maxLoyaltyPoint })
    }

    processMessage = (event) => {
        if (event.data.isAddFundingSourceClicked) {
            this.setState({ addFSClicked: true })
        }
        if (event.data.isPaypalButtonRendered) {
            setTimeout(() => {
                this.setState({ isPaypalButtonRendered: true })
            }, 1500);
        } else {
            this.setState({ isPaypalButtonRendered: false })
        }

        if (event.data.type && event.data.type === "paypal") {
            this.setState({
                isLoading: true
            })
            var receiptNumber = this.generateReceiptNumber();
            var response = event.data.details;
            if (response.status === "COMPLETED") {   // success case
                this.state.transactionId = response.purchase_units[0].payments.captures[0].id;   //transaction or capture id
                this.handlePostTransactionOfChannels("9", "PAYPAL", receiptNumber);
            } else {
                this.paymentFailedProcess("PAYPAL", receiptNumber)
            }
        } else {
            console.log("message => ", event.data);
        }

    }

    handleInputValueChangeForText(name, value) {
        this.state[name] = value;
        this.setState({ dummy: "dummy" });
    };

    updateWindowDimensions = () => {
        console.log("updating window diamentions")
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    paymentModalHandler = (dataObject) => {
        if (dataObject.type === "cancel") {
            this.props.callbackFromParent(false);
        } else if (dataObject.type === "submit") {
            var amountWithRewardPoint = 0
            if (this.state.isRewardPointUsingForPayment) {
                amountWithRewardPoint = this.state.totalAmountToPayForPrepaid
            }
            var rewardPointsUsed = parseFloat(this.state.totalAmountWithRedemption) * parseFloat(this.state.redemptionPoint)
            if (this.state.isRewardPointUsingForPayment && amountWithRewardPoint <= this.state.totalAmountWithRedemption) {
                this.props.callbackFromParent(false, false, "", "", rewardPointsUsed, "payWithRewardPoint");
            } else if (this.state.mainBalancePayment) {
                var amount = parseFloat(this.state.totalAmountToPayForPrepaid)
                var finalMaBalance = parseFloat((this.state.maBalance.replace(',','')))
                if (parseFloat(finalMaBalance) < parseFloat(amount)) {
                    Swal.fire({
                        title: this.props.locales.inSufficientBalMsgAddonPayment,
                        text: this.props.locales.rechargeToActivateOfferSwaTxtAddonPayment,
                        type: '',
                        showCancelButton: true,
                        confirmButtonText: 'Ok',  // Recharge
                        cancelButtonText: 'Cancel',
                        reverseButtons: true
                    }).then((result) => {
                        if (result.value) {
                            //this.setState({ isPaymentModalVisible: false, isRechargeComponentVisible: true })
                            this.props.callbackFromParent(false, false, "", "", "", "insufficientBalance");
                        }
                    });

                } else {
                    this.props.callbackFromParent(false, false, "", "", rewardPointsUsed, "mainBalance");
                }
            } else {
                if(this.props.registerDetails.generalResponse.type !== "changePlan"){
                    var sum = 0;
                    this.props.registerDetails.customize.addons.map((item, key) => {
                        sum = sum+parseFloat(item.count * item.offerAmount)
                    })
    
                    const currentCreditLimit = parseFloat(this.state.currentCreditLimit);
                    if(currentCreditLimit >= sum){
                        this.props.callbackFromParent(false, false, "", "", "", "nextMonthBill");
                    } else {
                        Swal.fire(this.props.locales.creditBalanceInsufficientTitleSwal)
                    }
                } else {
                    this.props.callbackFromParent(false, false, "", "", "", "nextMonthBill");
                }

               
            }
        } else if (dataObject.type === "plugNpay") {
            var totalRewardPointsUsed = parseFloat(this.state.totalAmountWithRedemption) * parseFloat(this.state.redemptionPoint)
            if (parseFloat(totalRewardPointsUsed) > 0) {
                this.state.finalPaymentAmount = parseFloat(this.state.totalAmountToPayForPrepaid)
            } else {
                this.state.finalPaymentAmount = this.state.totalAmountToPay
            }
            this.props.callbackFromParent(false, false, "", this.state.finalPaymentAmount, "", "plugNPay");
        }
    }

    handleInputValueCheckBox(name, event) {
        const value = event.target.checked;
        this.setState({ [name]: value })
    };

    handleInputValueChange(name, value) {
        this.state.finalPaymentAmount = value
        this.state.paypalAmount = value
        var receivedAmount = parseFloat((this.state.paymentAmount.replace(',', '')))
        if (parseFloat(this.state.finalPaymentAmount) > (parseFloat(receivedAmount))) {
            var diffAmount = parseFloat(this.state.finalPaymentAmount) - parseFloat(receivedAmount)
        }

        this.setState({
            diffAmount: diffAmount
        });
    }

    paymentFailedProcess(paymentTypeName, receiptNumber) {
        var dataToSend = {
            profileId: this.state.profileId,
            accountId: this.state.accountId,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            emailID: this.state.emailId,
            phoneNumber: this.state.phoneNumber,
            amount: GeneralUtils.formatNumberToStandardForm(this.state.finalPaymentAmount,this.props.configurationValues),
            transactionId: "",
            token: this.state.token,
            paymentType: paymentTypeName,
            fundingSource: this.state.fundingSource,
            cardExpiryDate: this.state.expiryDate,
            receiptNumber: receiptNumber,
            cardType: this.state.cardType
        }
        Network.executeAxios("insertPaymentDetails", "POST", dataToSend, (Response) => {
            if (Response.STATUS === "SUCCESS") {
                Swal.fire("Payment Failed", "", "")
            }
        });
    }

    handlePostTransactionOfChannels(paymentTypeId, paymentTypeName, receiptNumber) {
        var rechargeDetails = {}
        try {
            if (Object.keys(this.props.registerDetails.generalResponse.rechargeDetails)) {
                rechargeDetails = this.props.registerDetails.generalResponse.rechargeDetails
            }
        } catch (err) {

        }
        console.log("rechargeDetails>>>", rechargeDetails)
        var totalRewardPointsUsed = parseFloat(this.state.totalAmountWithRedemption) * parseFloat(this.state.redemptionPoint)

        if (Object.keys(rechargeDetails).length > 0) {
            var dataToSend = {
                "denomination": rechargeDetails.denomination,
                "rateCardId": rechargeDetails.rateCardId,
                "serviceId": this.props.registerDetails.givenAddress.serviceId
            }
            Network.executeAxios("rechargeRequest", "POST", dataToSend, (rechargeResponse) => {
                this.setState({ isLoading: false })
                if (rechargeResponse && rechargeResponse.resultParam && rechargeResponse.resultParam.resultCode) {
                    var resultCode = rechargeResponse.resultParam.resultCode;
                    var resultDesc = rechargeResponse.resultParam.resultDescription
                    if (resultCode === "1148") {
                        Swal.fire({
                            title: this.props.locales.rechargeSuccessfulInSwal,
                            text: this.props.locales.amountCreditedBalanceInSwal,
                            type: '',
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                            if (result.value) {
                                document.body.classList.remove('modal-open');
                                this.props.callbackFromParent(this.state.isRechargeModalVisible, this.state.isReceiptModalVisible, this.state.transactionId, this.state.finalPaymentAmount, "", "mainBalanceRecharge");
                            }
                        });
                    } else {
                        Swal.fire(resultDesc, "", "");
                    }
                } else {
                    Swal.fire(this.props.locales.internalErrorTitleInSwal, "", "");
                }
            })
        } else {
            Swal.fire({
                title: this.props.locales.paymentSuccessTitleInSwal,
                text: this.props.locales.paymentCreditTextInSwal,
                type: '',
                timer: 2000,
                showCancelButton: false,
                confirmButtonText: this.props.locales.okButtonTextInSwal,
            }).then((result) => {
                // window.location.reload();
                if (parseFloat(totalRewardPointsUsed) > 0) {
                    this.state.finalPaymentAmount = parseFloat(this.state.totalAmountToPayForPrepaid)
                } else {
                    this.state.finalPaymentAmount = this.state.totalAmountToPay
                }
                this.setState({ isPaymentComponent: false, isReceiptModalVisible: true })
                this.props.callbackFromParent(this.state.isPaymentComponent, this.state.isReceiptModalVisible, this.state.transactionId, this.state.finalPaymentAmount, totalRewardPointsUsed, "paypal");
            });
        }

    }

    initialisePlanComparison() {
        var allExistingAddonIds = []
        for (var a = 0; a < this.props.registerDetails.generalResponse.planComparisonData.currentAddonDetails.length; a++) {
            var currentObj = this.props.registerDetails.generalResponse.planComparisonData.currentAddonDetails[a]
            if (currentObj.retainable === "true") {
                for (var b = 0; b < this.props.registerDetails.generalResponse.planComparisonData.oldCartDetails.length; b++) {
                    var oldObj = this.props.registerDetails.generalResponse.planComparisonData.oldCartDetails[b]
                    if (oldObj.planId === currentObj.planId) {
                        allExistingAddonIds.push(currentObj.planId)
                    }
                }
            }
        }
        for (var j = 0; j < this.props.registerDetails.generalResponse.planComparisonData.oldCartDetailsDevices.length; j++) {
            var oldObj = this.props.registerDetails.generalResponse.planComparisonData.oldCartDetailsDevices[j]
            allExistingAddonIds.push(oldObj.planId)
        }
        this.setState({
            allExistingAddonIds: allExistingAddonIds
        })
    }

    populateAddonDetails() {
        var isAddonExists = false;
        const populateAddonCharges = this.props.registerDetails.customize.addons.map((item, key) => {
            var rewardPoint = parseFloat(item.count * item.offerAmount) * parseInt(this.state.redemptionPoint)
            var isExistingAddon = false
            if (this.state.allExistingAddonIds.includes(item.id)) {
                isExistingAddon = true
            }
            var price = GeneralUtils.formatNumberToStandardForm(item.count * item.offerAmount,this.props.configurationValues)
            if (isExistingAddon == false) {
                isAddonExists = true;
                return (
                    <div className="d-flex justify-content-between pb-2" style={{ fontWeight: 400 }}>
                        <div>{item.name}
                            {this.state.isHybridService ? <span style={{ fontSize: 12, fontWeight: 600 }}> ({item.connectionType})</span> : null}
                        </div>
                        <div>
                            <span>${price}</span>
                            {item.isRedeemable && this.state.totalAmountWithRedemption > 0 ?
                                <span className="" style={{ color: '#FF8F18', fontSize: 12 }}> ({rewardPoint} pts)</span>
                                : null}
                        </div>
                    </div>
                )
            }
        });

        if (isAddonExists) {
            return (populateAddonCharges);
        }
    }

    handleInputValueChangeForPaymentMethods(name, value) {
        if (name === "paymentMethodSelectionRadio" && value === "mainBalancePayment") {
            this.setState({
                mainBalancePayment: true,
                isPaypalChecked: false
            })
        } else if (name === "paymentMethodSelectionRadio" && value === "paypalPayment") {
            this.setState({
                mainBalancePayment: false,
                isPaypalChecked: true
            })
        }
    };

    render() {
        return (
            <div className="animated fadeIn col-md-12 p-0 m-0">
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : this.componentContent()}
            </div>
        );
    }

    componentContent() {
        return (
            <div className="">
                <SliderModal
                    isVisible={this.state.isPaymentModalVisible}
                    leftPartFlexValue={1.5}
                    rightPartFlexValue={1}
                    uniqueModalReferenceId="paymentModal"
                    mainHeading={this.props.locales.paymentSliderHeadingAddonPayment}
                    submitButtonText="Submit"
                    isResetButtonVisible={false}
                    isCancelButtonVisible={true}
                    isSubmitButtonVisible={parseFloat(this.state.totalAmountToPayForPrepaid) > 0 && this.state.mainBalancePayment === false && this.state.isPaypalChecked ? false : true}
                    isButtonGroupRequired={true}
                    isPayNowButtonVisible={parseFloat(this.state.totalAmountToPayForPrepaid) > 0 && this.state.mainBalancePayment === false && this.state.isPaypalChecked ? true : false}
                    amount={this.state.totalAmountToPayForPrepaid}
                    paypalClientId={this.state.paypalClientId}
                    isPaypalButtonRendered={this.state.isPaypalButtonRendered}
                    callback={this.paymentModalHandler}
                >

                    <div className="col-md-12">
                        {this.state.totalAmountWithRedemption > 0 && this.props.registerDetails.generalResponse.type !== "changePlan" ?
                            <div className="col-md-12 row m-0 p-0">
                                <div className="col-md-12 pt-1">
                                    <div style={{ fontSize: 14, fontWeight: 600, color: '#231F20' }}>{this.props.locales.totalAvailableRewardPointsTxtInAddonPayment} &nbsp;<span><button className="pl-3 tooltipContainer" id="rewardPointsInfoTooltip"><img src={infoIcon} alt="" /></button></span></div>
                                    <div style={{ fontSize: 30, color: '#231F20', fontWeight: 400 }}>{this.state.rewardPointsFromLMS}</div>
                                    <Tooltip placement="top" isOpen={this.state.isRewardInfoTooltipOpen} target="rewardPointsInfoTooltip" toggle={() => { this.setState({ isRewardInfoTooltipOpen: !this.state.isRewardInfoTooltipOpen }) }}>
                                        {this.props.locales.rewardPointsInfoTooltipText}
                                    </Tooltip>
                                </div>
                                <div className="col-md-12 pt-1">
                                    <div className="custom-control custom-checkbox">
                                        <input type="checkbox" className="custom-control-input" checked={this.state.isRewardPointUsingForPayment} id="rewardPointcheckbox" onChange={(event) => this.handleInputValueCheckBox("isRewardPointUsingForPayment", event)} />
                                        <label className="custom-control-label" htmlFor="rewardPointcheckbox" style={{ color: '#231F20', fontSize: 14 }}>{this.props.locales.useRewardPointsChkBoxValAddonPayment}</label>
                                    </div>
                                </div>
                            </div>
                            : null}

                        <div className="col-md-12 mt-4 flex-column d-flex" style={{ fontSize: 12 }}>
                            <div style={{ fontSize: 14, color: "#231F20", fontWeight: 400, }} className="mb-4">
                                {this.props.registerDetails.generalResponse.type === "changePlan" ?
                                    <div className="">
                                        <div className="d-flex justify-content-between pb-2" style={{ fontWeight: 400 }}>
                                            <span>{this.props.registerDetails.offers.name}
                                                {this.state.isHybridService ? <span style={{ fontSize: 12, fontWeight: 600 }}> ({this.props.registerDetails.offers.connectionType})</span> : null}</span>
                                            <span>$ {GeneralUtils.formatNumberToStandardForm(parseFloat(this.props.registerDetails.offers.offerAmount),this.props.configurationValues)}</span>
                                        </div>
                                        {parseFloat(this.props.registerDetails.offers.discount) > 0 ?
                                            <div className="d-flex justify-content-between pb-2" style={{ fontWeight: 400 }}>
                                                <span>{this.props.registerDetails.offers.discountName}</span>
                                                <span>$ {GeneralUtils.formatNumberToStandardForm(parseFloat(this.props.registerDetails.offers.discount),this.props.configurationValues)}</span>
                                            </div>
                                            : null}
                                        {/* {parseFloat(this.state.addonTotal) > 0 ?
                                    <div className="d-flex justify-content-between pb-2" style={{fontWeight: 400}}>
                                        <span>Addon(s) Total ({this.props.registerDetails.customize.addons.length})</span>
                                        <span>$ {GeneralUtils.formatNumberToStandardForm(parseFloat(this.state.addonTotal))}</span>
                                    </div>
                                    : null } */}
                                        {this.props.cache.currentPlanDetails.isContractExpired == false ?
                                            <div className="d-flex justify-content-between pb-2" style={{ fontWeight: 400 }}>
                                                <span>Contract Violation Charge</span>
                                                <span>$ {GeneralUtils.formatNumberToStandardForm(parseFloat(this.props.registerDetails.contractDetails.price),this.props.configurationValues)}</span>
                                            </div>
                                            : null}
                                    </div>
                                    :
                                    null
                                }
                                {this.populateAddonDetails()}
                                {this.state.isRewardPointUsingForPayment ?
                                    <div className="d-flex justify-content-between pb-2">
                                        <span>{this.props.locales.rewardPointRedeemptionSecHeadingAddonPayment} <span style={{ color: '#FF8F18', fontSize: 12, fontWeight: 500 }}> (1$ = {this.state.redemptionPoint} points)</span></span>
                                        <span style={{ fontWeight: 600, color: "#36B07F" }}>{parseFloat(this.state.totalAmountWithRedemption) * parseFloat(this.state.redemptionPoint)}</span>
                                    </div>
                                    : null}
                                {/* <div className="d-flex justify-content-between pb-2" >
                                  <span>{this.props.locales.cartTotalSecHeadingAddonPayment}</span>
                                  <span style={{fontWeight: 600}}>$ {GeneralUtils.formatNumberToStandardForm(this.state.totalAmountToPay,this.props.configurationValues)}</span>
                              </div> */}

                                {/* prepaid */}
                                {this.state.isPrepaidAddonExists && this.state.isHybridService == false ?
                                    <div>
                                        <div className="d-flex justify-content-between pb-2" style={{ fontWeight: 600 }}>
                                            <span>{this.props.locales.totalToPaySecHeadingAddonPayment}</span>
                                            {this.state.isRewardPointUsingForPayment ?
                                                <span>$ {GeneralUtils.formatNumberToStandardForm(this.state.totalAmountToPayForPrepaid,this.props.configurationValues)}</span>
                                                :
                                                <span>$ {GeneralUtils.formatNumberToStandardForm(this.state.totalAmountToPay,this.props.configurationValues)}</span>
                                            }
                                        </div>
                                        <div className="d-flex justify-content-between pb-2">
                                            <span style={{ fontWeight: 500, color: "#0049A5", fontSize: 11 }}>{this.props.locales.amountCanBePaidWithMsgAddonPayment}</span>
                                        </div>
                                    </div>
                                    : null}

                                {/* postpaid */}
                                {this.state.isPrepaidAddonExists == false ?
                                    <div>
                                        <div className="d-flex justify-content-between pb-2" style={{ fontWeight: 600 }}>
                                            <span>{this.props.locales.cartTotalSecHeadingAddonPayment}</span>
                                            <span>$ {GeneralUtils.formatNumberToStandardForm(parseFloat(this.state.totalCharges),this.props.configurationValues)}</span>
                                        </div>
                                        <div className="d-flex justify-content-between py-2" style={{ color: '#F78521' }}>
                                            <span>{this.props.locales.creditBalanceLabelForPostpaid}</span>
                                            <span>$ {this.state.currentCreditLimit}</span>
                                        </div>

                                        <div className="d-flex justify-content-between pb-2">
                                            <span style={{ fontWeight: 500, color: "#0049A5", fontSize: 11 }}>{this.props.locales.amountCanBePaidWithMsgForPostpaid}</span>
                                        </div>
                                    </div>
                                    : null}

                                {/* hybrid */}
                                {this.state.isHybridService == true ?
                                    <div>
                                        <hr />
                                        <div className="d-flex justify-content-between" style={{ fontWeight: 600 }}>
                                            <span>{this.props.locales.cartTotalSecHeadingAddonPayment}</span>
                                            <span>$ {GeneralUtils.formatNumberToStandardForm(parseFloat(this.state.totalCharges),this.props.configurationValues)}</span>
                                        </div>
                                        <div className="d-flex justify-content-between py-4">
                                            <span style={{ fontWeight: 500, color: "#0049A5", fontSize: 11 }}>{this.props.locales.amountCanBePaidWithMsgForHybrid}</span>
                                        </div>
                                        <div className="d-flex justify-content-between" style={{ fontWeight: 600 }}>
                                            <span>{this.props.locales.totalToPaySecHeadingAddonPayment}</span>
                                            {this.state.isRewardPointUsingForPayment ?
                                                <span>$ {GeneralUtils.formatNumberToStandardForm(this.state.totalAmountToPayForPrepaid,this.props.configurationValues)}</span>
                                                :
                                                <span>$ {GeneralUtils.formatNumberToStandardForm(this.state.totalAmountToPay,this.props.configurationValues)}</span>
                                            }
                                        </div>
                                    </div>
                                    : null}
                            </div>
                        </div>
                    </div>
                    {this.state.isPrepaidAddonExists && ((this.state.isRewardPointUsingForPayment && this.state.totalAmountToPayForPrepaid > 0)
                        || (this.state.isRewardPointUsingForPayment == false && this.state.totalAmountToPay > 0)) ?
                        <div>
                            <div className="col-md-12 px-4 pt-4">
                                <div className="col-md-12 px-0">
                                    <div className="pb-1 mb-3" style={{ color: '#231F20', fontSize: 18, fontWeight: 700, borderBottom: '1px solid #b3b3b3' }}>{this.props.locales.allPaymentMethodsHeadingAddonPayment}</div>
                                </div>
                            </div>
                            <div className="col-md-12 px-4 mb-5">
                                <div style={{ border: '1px solid #A3B4BC', borderRadius: 6 }}>
                                    <div className="paymentMethodRadioContainer d-flex flex-column ">

                                        {this.state.isPaymentFromMainBalanceAllowed ?
                                            <div className=" py-3 px-3 m-0 " style={{ borderBottom: '1px solid #A3B4BC' }}>
                                                <div className="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" id="mainBalancePayment" className="custom-control-input"
                                                        checked={this.state.mainBalancePayment}
                                                        onChange={(event) => this.handleInputValueChangeForPaymentMethods("paymentMethodSelectionRadio", "mainBalancePayment")}
                                                    />
                                                    <label className="custom-control-label" htmlFor="mainBalancePayment" >{this.props.locales.payWithMainBalanceAddonPayment} - ${GeneralUtils.formatNumberToStandardForm(this.state.maBalance,this.props.configurationValues)}</label>
                                                </div>
                                            </div>

                                            : null
                                        }

                                        {this.state.payaplPaymentMethodAllowed ?
                                            <div className=" py-3 px-3 m-0 " style={{ borderBottom: '1px solid #A3B4BC' }}>
                                                <div className="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" id="paypalPayment" className="custom-control-input"
                                                        checked={this.state.isPaypalChecked}
                                                        onChange={(event) => this.handleInputValueChangeForPaymentMethods("paymentMethodSelectionRadio", "paypalPayment")}
                                                    />
                                                    <label className="custom-control-label" htmlFor="paypalPayment" >{this.props.locales.payWithPlugNPay}</label>
                                                </div>

                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null}
                </SliderModal>
                {this.state.isRechargeComponentVisible ?
                    <RechargeComponent amount=""
                        accountId={this.props.registerDetails.confirmation.accountId}
                        billDueDate=""
                        billStartDate=""
                        billEndDate=""
                        billPeriod=""
                        billId=""
                        firstName={this.props.registerDetails.confirmation.firstName}
                        lastName={this.props.registerDetails.confirmation.lastName}
                        phoneNumber={this.props.registerDetails.confirmation.contactNumber}
                        emailId={this.props.registerDetails.confirmation.contactEmailAddress}
                        profileId={this.props.registerDetails.confirmation.profileId}
                        serviceId={this.props.registerDetails.givenAddress.serviceId}
                        planId={this.props.registerDetails.confirmation.currentPlanId}
                        callbackFromRechargeComponent={this.myCallback}
                    />
                    : null}

            </div>
        );
    }
}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        registerDetails: state.registerDetails,
        configurationValues: state.configurationValues
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

const PaymentComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentComponent)

export default PaymentComponentContainer;
